import { render } from "./MfDetailRowTab.vue?vue&type=template&id=18a9856d&scoped=true"
import script from "./MfDetailRowTab.vue?vue&type=script&lang=js"
export * from "./MfDetailRowTab.vue?vue&type=script&lang=js"

import "./MfDetailRowTab.vue?vue&type=style&index=0&id=18a9856d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a9856d"]])

export default __exports__